/**
 * apidocs.mentorivo.com — geliştirici dokümantasyonunun host sabitleri.
 *
 * Bu dosyayı `proxy.ts` (Edge çalışma zamanı), route handler'lar ve sunucu
 * bileşenleri okuyor; bu yüzden İÇİNDE çalışma zamanına özel import YOK.
 *
 * Backstage'in aksine burada gizlenecek bir şey yok: dokümantasyon herkese
 * açık olmak için var (yapay zekâ ajanlarının arayıp bulabilmesi amacın
 * kendisi). Sabit yedek yine de duruyor, çünkü proxy Edge'de kökteki
 * `.env`i göremiyor — gerekçe `lib/backstage.ts` başlığında.
 *
 * `@mentorivo/shared/locales` Edge'de güvenli: yalnız saf fonksiyonlar ve zod.
 */
import { toLocale } from '@mentorivo/shared/locales';

export const APIDOCS_URL = (process.env.APIDOCS_URL ?? 'https://apidocs.mentorivo.com').replace(
  /\/+$/,
  '',
);

export const APIDOCS_HOST = APIDOCS_URL.replace(/^https?:\/\//, '')
  .replace(/\/.*$/, '')
  .toLowerCase();

/**
 * Dokümanın dil önekli kökü — ana siteden dokümana giden HER bağlantı bunu
 * kullanıyor (footer, panel).
 *
 * Önek burada yazılıyor çünkü apidocs ayrı bir alan adı: `@/i18n/navigation`
 * içindeki `Link` mutlak adrese /tr eklemez, doküman da kendi dilini
 * yalnızca yoldan okur. Öneksiz bırakılsaydı köke düşen istek tarayıcının
 * `Accept-Language`ına göre yönleniyor — Türkçe siteyi İngilizce tarayıcıda
 * okuyan kişi İngilizce dokümana varırdı.
 */
export function apidocsHref(locale: string): string {
  return `${APIDOCS_URL}/${toLocale(locale)}`;
}

/// Geliştirici API'sinin kök adresi — dokümandaki her örnek bunu basıyor.
export const PUBLIC_API_BASE = 'https://api.mentorivo.com/v1';

/// Platform MCP sunucusu (anahtarlı) ve doküman MCP sunucusu (anahtarsız).
export const PLATFORM_MCP_URL = 'https://api.mentorivo.com/mcp';
export const DOCS_MCP_URL = `${APIDOCS_URL}/mcp`;

/**
 * Dil öneki OLMADAN sunulan, makinelerin okuduğu adresler. Proxy bunları
 * dil önekine yönlendirmiyor: `llms.txt` ve `/mcp` sabit adreslerde yaşar,
 * `/en/llms.txt`e yönlendirilen bir ajan onu bulamaz.
 */
export const APIDOCS_ROOT_PATHS = new Set(['/mcp']);
